import styled from 'styled-components';

import TextInput from '../../../../shared/FormStyles/TextInput.jsx';
import { ClosedLock } from '../../../../assets';

export const MessageTextInput = ({ isReminderTab, ...props }) => {
  return (
    <TextInput
      {...props}
      disabledVariant="whiteBg"
      disabled={isReminderTab}
      extraElements={isReminderTab && <LockIcon src={ClosedLock} />}
    />
  );
};

const LockIcon = styled.img`
  position: absolute;
  right: 15.5px;
  top: 30.5px;
`;
